import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "font-awesome/css/font-awesome.css";
import { Message } from 'element-ui';
import './permission'
import JsonViewer from 'vue-json-viewer';
import W2Vue from "./w2";
import { http } from './utils/http'
import { fmt } from './utils/common'
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import './styles/index.scss';
import './vantui';
import dropdownMask from './directives/dropdown-mask.js'
// 注册指令
Vue.directive('dropdown-mask', dropdownMask);



Vue.use(Antd);
Vue.use(ElementUI, { size: 'small', });
Vue.use(W2Vue);
Vue.use(JsonViewer);
Vue.use(vuescroll, {
  ops: {
    bar: {
      background: "#c1c1c1",
      opacity: 0.8,
      size: "6px",
      disable: false,
    },
  },
});


Vue.config.productionTip = false

//vue全局方法  
Vue.prototype.$http = http;
Vue.prototype.$fmt = fmt;

appBoot()

function isRuntimeWorkbenchShell() {
  const hash = window.location.hash || '';
  return hash.includes('/todo-center') || hash.includes('/ai-workbench') || window.location.hostname.includes('pages.dev');
}

function defaultCfgHelper() {
  return {
    app_menu_width: "200",
    app_menu_icon_show: "levelOne",
    app_menu_icon_default: "el-icon-menu",
    app_menu_theme: "light",
    app_menu_collapse_enableSwitch: "1",
    app_menu_collapse_collapsed: localStorage.getItem('is_collapsed') == 'true' ? '1' : '0',
    'Agree.EnableRemark': '0',
    'Agree.NoConfirm': '0',
    'v3.tabs.pc': 'init,todo,sent,did,copy',
    'v3.tabs.mobile': 'todo,sent,init,did,copy',
    'v3.todo.invisible_tags': '',
    'v3.class_position': 'title_icon',
    'v3.mobile.tools_layout': '1',
    'Initiate.FromPC.Width1': 200,
    'Initiate.FromPC.Width2': 80,
    'v3.pc.pager': '10,10,20,50,100,200',
  };
}

async function appBoot() {

  // let login = await http.get(window.expandUrl('%dm_sso%/api/sso/isready?json=1'));
  // if (!login.LoginName) return alert('先登录w2门户，再刷新此页面');
  let resModule = { data: { Warning: "" } };
  let cfgHelper = defaultCfgHelper();

  if (!isRuntimeWorkbenchShell()) {
    resModule = await http.post("/api/Page/LoadConfig", { SystemConfigKeys: { ["Compare.Enabled"]: "0", } });
    let { Warning } = resModule.data;
    if (Warning) {
      Message({ type: 'warning', dangerouslyUseHTMLString: true, duration: 0, showClose: true, message: Warning });
    }
    cfgHelper = await http.post("/options_sapi.axd", defaultCfgHelper());
  }

  if (process.env.NODE_ENV == 'development') {
    cfgHelper['Agree.EnableRemark'] = '0';
    cfgHelper['Agree.NoConfirm'] = '0';
    cfgHelper['v3.tabs.pc'] = 'init,timeout:超时,todo,sent,did,copy,fav,handover';
    cfgHelper['v3.tabs.mobile'] = 'init,timeout:超时,todo,sent,did,copy,fav,handover';
    cfgHelper['v3.class_position'] = 'left';
    cfgHelper['v3.mobile.tools_layout'] = '2';
    cfgHelper['v3.pc.pager'] = '10,10,20,50';
  }

  // vue初始化
  window.$rootVM = new Vue({
    router,
    provide() {
      return {
        CFG: cfgHelper,
      };
    },
    data() {
      return {
        // vc: new VConsole(),
        requestCount: 0,
        loadingTasks: [],
        resModule: resModule.data,
        eventHub: new Vue(),
        cfgHelper
      }
    },
    render: h => h(App)
  }).$mount('#app')


}
